import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';
import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import styled from 'styled-components';

const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default styled(DatePicker)`
  padding: 3px 3px 3px 8px;
  border: 1px solid #e6e6e6;
  input {
    font-weight: 300;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
    width: 87px;
  }
  &.ant-picker:hover,
  .ant-picker-focused {
    border-color: #e6e6e6;
    border-right-width: 1 px !important;
    box-shadow: 0 0 0 2px #e6e6e647;
  }
`;
